import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { HorariosService } from 'src/app/services/horarios.service';
import { Router } from '@angular/router';
import { ConveniosService } from 'src/app/services/convenios.service';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-horarios-client',
  templateUrl: './horarios-client.component.html',
  styleUrls: ['./horarios-client.component.scss']
})
export class HorariosClientComponent implements OnInit, OnChanges {
  @Output() horarioSelecionado = new EventEmitter<any>();
  @Input() convenioSel: any;
  @Input() planoSel: any;
  @Input() especialidadeSel: any;
  @Input() horarios: any = [];
  @Input() selecionaHorario: any;
  @Input() stepper: any;
  @Input() horarioSel: any;
  @Input() updateSessionData: any;
  @Input() sessionData: any;
  @Input() carregandoHorarios: boolean;
  @Input() procedimento: any;
  @Input() agendaNomes: any
  minDate = new Date();
  date = new Date();
  breakpoint: number;
  period: 'ambos' | 'manha' | 'tarde' = 'ambos'
  agenda: string = ''
  @Output() selectedAgenda = new EventEmitter<string>()
  @Output() carregarHorarios = new EventEmitter<any>();
  condition = this.horarios.length < 0
  validarCarteirinhaValidade = false
  carteirinhaValidade: string = ''

  agendaControl = new FormControl()
  filteredAgendaOptions: Observable<string[]>

  constructor(
    private horariosService: HorariosService,
    private authService: AuthService,
    private conveniosService: ConveniosService,
  ) {
    this.authService.userLoggedOut.subscribe(userLoggedOut => {
      // Se usuário fez logout usando ícone no menu na barra, atualiza
      if (userLoggedOut) {
        this.convenioSel = null;
        this.planoSel = null;
        this.especialidadeSel = null;
        this.horarioSel = null;
        this.date = new Date();
      }
    });
  }

  ngOnInit() {
    this.breakpoint = (window.innerWidth <= 400) ? 1 : 3;

    const horariosPeriodo = sessionStorage.getItem('horarios-periodo')
    if (horariosPeriodo)
      this.period = horariosPeriodo as 'ambos' | 'manha' | 'tarde'

    this.getOtimusURL()

    this.setupAgendaAutocomplete()
    this.sortAgendaNames()
  }

  ngOnChanges() {
    if(this.horarios && this.horarios.length){
      this.verifyRules()
    }

    this.sortAgendaNames()
  }

  sortAgendaNames() {
    if (this.agendaNomes) {
      this.agendaNomes.sort((a, b) => a.localeCompare(b))
    }
  }

  setupAgendaAutocomplete() {
    this.filteredAgendaOptions = this.agendaControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filterAgenda(value || ''))
    )
  }

  _filterAgenda(value: string): string[] {
    const filterValue = value.toLowerCase()
    return this.agendaNomes.filter(option =>
      option.toLowerCase().includes(filterValue)
    )
  }

  onResize(event) {
    this.breakpoint = (event.target.innerWidth <= 400) ? 1 : 3;
  }

  onVoltarClick() {
    this.stepper.previous();
  }

  onContinuarClick() {
    if (this.sessionData.userData) {
      this.stepper.selectedIndex = 3;
    } else {
      this.stepper.next();
    }
  }

  onChangeDate() {
    sessionStorage.setItem('horarios-periodo', this.period)
    this.carregarHorarios.emit()
  }

  onChangeSelectedAgenda() {
    sessionStorage.setItem('schedule-name', this.agenda)
    this.selectedAgenda.emit(this.agendaControl.value)
  }

  isVencida(diaErrado: string) {
    const validadeDate = new Date(this.conveniosService.validadeCarteirinha)
    const diaSplit = diaErrado.split('-')
    const dia = `${diaSplit[2]}-${diaSplit[1]}-${diaSplit[0]}`
    const diaDate = new Date(dia)

    return +validadeDate < +diaDate
  }

  rules: any[] = []
  agendasHorarios: any[] = []

  getOtimusURL() {
    this.horariosService.getOtimusURL().subscribe({
      next: (resp:any) => {
      this.horariosService.otimusUrl = resp.find((el: any) => el.chave === `Otimus_URL`).valor
      
      this.getAllRules()
    },
    error: (err: unknown) => {
      
    }
  })
  }

  convertDate(date:string) {
    const splittedDate = date.split('-')
    return `${splittedDate[2]}-${splittedDate[1]}-${splittedDate[0]}`
  }

  verifyRules(ranOnce?: boolean) {
    if(!this.rules.length) return

    let userData = JSON.parse(sessionStorage.getItem('userData'))
    if(!userData) return
    
    this.carregandoHorarios = true
    
    const agendasHorarios = []
    this.horarios.forEach(hor => {
      hor.agendas.forEach(ag => agendasHorarios.push({
        'unique_schedule_id': `${this.convertDate(hor.data)}_${ag.agendaId}`,
        'agenda_id': ranOnce ? ag.agendaProfMedicoId : ag.agendaId,
        'convenio_id': this.convenioSel.integracao_id,
        'agenda_tipo': ranOnce ? null : ag.agendaTipo,
        'data': this.convertDate(hor.data),
        'procedimento_id': this.procedimento.procedimento_integracao_id,
        'modalidade': this.procedimento.servico_modalidade,
        'plano_descricao': this.planoSel.descricao || null,
      }))
    })
    
    this.agendasHorarios = agendasHorarios.filter(agHor => {
      const foundSimilar = this.rules.find((rule: any) => {
        return (
          ranOnce
          ? (!rule.agenda_tipo && rule.agenda_id === agHor.agenda_id)
          : (rule.agenda_id === agHor.agenda_id && rule.agenda_tipo === agHor.agenda_tipo)
        ) &&
        (rule.convenio_id ? rule.convenio_id === agHor.convenio_id : true) &&
        (rule.procedimento_id ? rule.procedimento_id === agHor.procedimento_id : true) &&
        (rule.modalidade ? rule.modalidade === agHor.modalidade : true);      
      })
      return !!foundSimilar
    })


    if(!this.agendasHorarios.length) {
      if(!ranOnce){
        this.verifyRules(true)
        return
      }
      this.carregandoHorarios = false
      return
    }

    this.agendasHorarios.forEach((hor, i) => {
      const formattedBody = {...hor, paciente_id: userData.integracao_id}
      this.horariosService.getRule(formattedBody).subscribe({
        next: (resp: any) => {
          const data = hor.unique_schedule_id.split('_')[0];
          const agendaId = hor.unique_schedule_id.split('_')[1];
          if (resp.data.regra_violada && resp.data.regra_violada.acao === 'nao permitir') {
  
            if(!this.horarios) return
            const horariosAux = this.horarios.forEach((hor) => {
              if (this.convertDate(hor.data) === data) {
                hor.agendas = hor.agendas.filter((ag) => ag.agendaId !== agendaId);
              }
              return hor
            });
            this.horarios = horariosAux
          }
          if(i === this.agendasHorarios.length - 1 && !ranOnce) {
            this.verifyRules(true)
            return
          } 
          this.carregandoHorarios = false
          return
        }, error: (err: unknown)  => {
          this.carregandoHorarios = false
        }
      });      
    })
  }
  
  getAllRules() {
    this.horariosService.getRules().subscribe((resp:any) => {
      this.rules = resp.data
      
      if(this.horarios && this.horarios.length){
        this.verifyRules()
      }
    })
  }
}
